import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Brand } from '../generated';
import { useGrowintelService } from './useGrowintelService';

export default function useWatchlist() {
  const service = useGrowintelService();
  const { data, isFetching, refetch } = useQuery({
    queryKey: ['watchlist'],
    queryFn: async (): Promise<Brand[] | null | undefined> => {
      if (!service) return null;

      try {
        const response = await service?.watchlistAPI.getWatchlistWatchlistGet(
          1,
          Number.MAX_SAFE_INTEGER,
        );
        return response?.data.items;
      } catch (error) {
        console.error('error during fetching watchlist', error);
        throw error;
      }
    },
    gcTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: false,
  });

  useEffect(() => {
    if (service && !data?.length) refetch();
  }, [service]);

  const isWatchlisted = (brandId?: string) => {
    if (!data || !brandId) return false;
    const watchlist = data ?? [];
    return watchlist.some((brand) => brand.id?.toString() === brandId);
  };

  return {
    watchlist: data,
    refetchWatchlist: refetch,
    isWatchlistLoading: isFetching,
    isWatchlisted,
  };
}
